import React from 'react';
import { Link } from 'react-router-dom';
import './SiteFooter.css';

const SMARTMARKETING_URL = 'https://getsmart.marketing';

const SiteFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" role="contentinfo">
      <nav className="site-footer__links" aria-label="Legal and policies">
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-of-service">Terms of Service</Link>
      </nav>
      <p className="site-footer__meta">
        Copyright Back to School Forms {year}
        <span className="site-footer__sep" aria-hidden="true">
          |
        </span>
        Designed by{' '}
        <a href={SMARTMARKETING_URL} target="_blank" rel="noopener noreferrer">
          Smartmarketing
        </a>
      </p>
    </footer>
  );
};

export default SiteFooter;
